import {Injectable} from '@angular/core';
import {ApiService} from './api.service';
import {BehaviorSubject, Observable} from 'rxjs';
import {User} from '../models/user/user';
import {tap} from 'rxjs/operators';
import {UserSettings} from '../models/user/user-settings';
import {DefaultDataService} from './default-data.service';
import {ViewInfo} from '../models/user/view-info';
import {ChartPack} from '../models/chart/chart-pack';
import {AppService} from './app.service';

@Injectable({
  providedIn: 'root'
})
export class UserService {

  user = new BehaviorSubject<User>(null);
  token = '';

  constructor(private apiService: ApiService, private appService: AppService,
              private defaultDataService: DefaultDataService) { }

  checkInvite(): Observable<{isExist: boolean, user: User}> {
    return this.apiService.checkInvite().pipe(
      tap((data: {isExist: boolean, user: User}) => {
        this.user.next(data.user);
        this.token = localStorage.getItem('token');
        if (this.getUser().language) {
          this.appService.changeLanguage(this.getUser().language);
          localStorage.setItem('lang', this.getUser().language);
        }
      })
    );
  }

  checkAuth(code: string, ref: string) {
    return this.apiService.checkAuth(code, ref).pipe(
      tap((data: {isExist: boolean, user: User, token: string}) => {
        this.user.next(data.user);
        this.token = data.token;
        if (this.getUser().language) {
          this.appService.changeLanguage(this.getUser().language);
          localStorage.setItem('lang', this.getUser().language);
        }
      })
    );
  }

  isAdmin(): boolean {
    return this.user.value.isAdmin;
  }

  isPartner(): boolean {
    return  this.user.value.partner;
  }

  isCoach(): boolean {
    return  this.user.value.coach;
  }

  isSFCoach(): boolean {
    return  this.user.value.isSFCouch;
  }

  isBTBCoach(): boolean {
    return  this.user.value.isBTBCouch;
  }

  isFireStormCouch(): boolean {
    return  this.user.value.isFireStormCouch;
  }

  isAddPayment(): boolean {
    return this.user.value.isAddPayment;
  }

  isLFAvailable(): boolean {
    return this.user.value.email === 'rudenok.evgeni@gmail.com'
      || this.user.value.email === 'den.korolenok@gmail.com'
      || this.user.value.email === 'luckyplayerok@gmail.com'
      || this.user.value.email === 'prology777@gmail.com'
      || this.user.value.email === 'dimaosin23357@gmail.com'
      || this.user.value.email === 'peahematop@gmail.com'
      || this.user.value.email === 'jen.lesnoy@gmail.com'
      || this.user.value.email === 'leshasavablr@gmail.com'
      || this.user.value.email === 'jkulakovski@gmail.com'
      || this.user.value.email === 'corstenpoker@gmail.com'
      || this.user.value.email === 'svalsezp@gmail.com'
      || this.user.value.email === '80444960703a@gmail.com'
      || this.user.value.email === 'pokerhazuem@gmail.com'
      || this.user.value.email === 'dmitrytkachuk88@gmail.com'
      || this.user.value.email === 'akord657aman@gmail.com'
      || this.user.value.email === 'denisddv8@gmail.com'
      || this.user.value.email === 'ust1222@gmail.com'
      || this.user.value.email === '4xilya@gmail.com'
      || this.user.value.email === 'ernest.elperin@nure.ua'
      || this.user.value.email === 'kleskisback@gmail.com'
      || this.user.value.email === 'ramantamilin@gmail.com'
      || this.user.value.email === 'letoblizko77@gmail.com'
      || this.user.value.email === 'biaheza@gmail.com'
      || this.user.value.email === 'mazurik2512@gmail.com'
      || this.user.value.email === 'denik8060@gmail.com'
      || this.user.value.email === 'ji6nd@tut.by'
      || this.user.value.email === 'andruivan43@gmail.com'
      || this.user.value.email === 'pavel.lomako.90@gmail.com'
      || this.user.value.email === 'timurnikiforov228@gmail.com'
      || this.user.value.email === 'kp008a@gmail.com'
      || this.user.value.email === 'fernandovpoker@gmail.com'
      || this.user.value.email === '89500715305mi4i@gmail.com'
      || this.user.value.email === 'thomasfjanssens@gmail.com'
      || this.user.value.email === 'pokerherofinance@gmail.com'
      || this.user.value.email === 'vgsm81@yandex.ru'
      || this.user.value.email === 'ph.frontden@gmail.com'
      || this.user.value.email === 'genczlerpoker@gmail.com'
      || this.user.value.email === '1feland11@gmail.com'
      || this.user.value.email === 'sslimxl@gmail.com'
      || this.user.value.email === 'mirosh133@gmail.com'
      || this.user.value.email === 'ldeputatl86@gmail.com'
      || this.user.value.email === 'sergey.tarelko89@gmail.com'
      || this.user.value.email === 'pendalf.ua@gmail.com'
      || this.user.value.email === 'ilya160899@gmail.com'
      || this.user.value.email === 'dimaamelchenya@gmail.com'
      || this.user.value.email === 'jomarikriki@gmail.com'
      || this.user.value.email === 'dsolgan@gmail.com'
      || this.user.value.email === 'mnv199020@gmail.com'
      || this.user.value.email === 'omagadza4to@gmail.com'
      || this.user.value.email === 'momentomore55@gmail.com'
      || this.user.value.email === 'saiger55@gmail.com'
      || this.user.value.email === 'kuzkuzihar3@gmail.com'
      || this.user.value.email === 'vlados9993@gmail.com'
      || this.user.value.email === 'blackberryspingg@gmail.com'
      || this.user.value.email === 'pretenderua@gmail.com'
      || this.user.value.email === 'dleekorp@gmail.com'
      || this.user.value.email === 'arsenal_gtr@mail.ru'
      || this.user.value.email === 'andrusha.sam80@gmail.com'
      || this.user.value.email === 'wierd77777@gmail.com'
      || this.user.value.email === 'rykovvvv@gmail.com'
      || this.user.value.email === 'slepoyohotnikss@gmail.com'
      || this.user.value.email === 'lavrusha.evgenii@gmail.com'
      || this.user.value.email === 'johnfeel82@gmail.com'
      || this.user.value.email === 'jake342669@gmail.com'
      || this.user.value.email === 'granitas.fk@gmail.com'
      || this.user.value.email === 'dkazusik@gmail.com'
      || this.user.value.email === 'tango.amant@gmail.com'
      || this.user.value.email === 'maksbond787@gmail.com'
      || this.user.value.email === 'alejj4ke@gmail.com'
      || this.user.value.email === 'mitron870@gmail.com';
  }

  isTrial(): boolean {
    return this.user.value.isTrial;
  }

  getToken(): string {
    return this.token;
  }

  setToken(token: string) {
    this.token = token;
  }

  getSettings(): UserSettings {
    return this.user.value.settings;
  }

  getViewInfo(): ViewInfo {
    const settings: UserSettings = this.getSettings();
    const viewInfo: ViewInfo = {};
    viewInfo.isStackInBB = this.defaultDataService.isStackInBB(settings.stackView);
    viewInfo.roundTo = settings.roundTo;
    viewInfo.isEffectiveStackShown = settings.isEffectiveStackShown;
    viewInfo.symbol = settings.stackView.symbol;
    return viewInfo;
  }

  getUser(): User {
    return this.user.value;
  }

  isStackInBB(user: User): boolean {
    return this.defaultDataService.isStackInBB(user.settings.stackView);
  }

  updateUser(user: User): Observable<User> {
    return this.apiService.updateUser(user);
  }

  applyPromoCode(promocode: string): Observable<any> {
    return this.apiService.applyPromoCode(promocode);
  }

  applyPromocodeSPNS(promocode: string): Observable<any> {
    return this.apiService.applyPromocodeSPNS(promocode);
  }

  isSPNSChartExist(): boolean {
    return this.isChartExist('c7804228-b578-4744-99b3-55ae9b8c5786');
  }

  isSPNSCourseChartExist(): boolean {
    return this.isChartExist('573eadc6-77d2-48a7-b4fe-e792e0217ecb');
  }

  isAsymmetricChartExist(): boolean {
    return this.isChartExist('225b086a-0ef0-40e8-b4ae-4b82b018afcf');
  }

  isSawCrewChartExist(): boolean {
    return this.isChartExist('0ad1a501-d8a8-4996-b8dd-df4e651f36d2');
  }

  isGtoPackExist(): boolean {
    return this.isChartExist('8bf4e61c-6e22-443a-8539-f0a2ca27e041');
  }

  isNitroPackExist(): boolean {
    return this.isChartExist('a87cb73a-ad76-4ca2-924b-576240fc019b');
  }

  isNashPackExist(): boolean {
    return this.isChartExist('0d90dc5a-ac7c-4930-af79-4920ecef54bb');
  }

  isChartExist(uuid: string): boolean {
    if (!this.user.value.chartGroups || this.user.value.chartGroups.length === 0) {
      return false;
    }
    return this.user.value.chartGroups.find(
      (chart: ChartPack) => chart.uuid === uuid) !== undefined;
  }

  subDaysLeft(): number {
    const oneDay = 24 * 60 * 60 * 1000;
    const today = new Date();
    if (this.user.value.subTo === null || this.user.value.subTo.getTime() - today.getTime() < 0) {
      return 0;
    }
    return Math.round(Math.abs((this.user.value.subTo.getTime() - today.getTime()) / oneDay));
  }

}
